"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _hotjar.default;
  }
});
var _hotjar = _interopRequireDefault(require("./hotjar"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }